import { useManageSubscriptionMeta } from '../../api/subscription-management/useManageSubscriptionMeta';
import { useManageSubscriptionData } from '../../api/subscription-management/useMagazinSubscriptionData';
import { mapHeader } from '../../shared/subscription-management/mappings/mapHeader';
import { mapSimpleBody } from './mappings/mapSimpleBody';
import { mapExtendedBody } from './mappings/mapExtendedBody';
import { ProductEntry } from '../../store/api';
import { useTranslation } from 'react-i18next';

export const useManageSubscriptionsTableData = ({
    page,
    pageSize,
    onAddCopy,
    onExpireIssues
}: {
    page: number;
    pageSize: number;
    onAddCopy: (item: ProductEntry) => void;
    onExpireIssues: (item: ProductEntry) => void;
}) => {
    const { t } = useTranslation();
    const { data: metaData, isLoading: isLoadingMeta } = useManageSubscriptionMeta();
    const { data: subscriptions, isLoading: isLoadingData } = useManageSubscriptionData({
        pageSize,
        page,
        includeExpiredSubscriptions: true
    });

    return {
        tableHeader: metaData ? mapHeader(metaData, t) : undefined,
        tableBody:
            metaData && subscriptions
                ? metaData.includesSharedCopies
                    ? mapExtendedBody(subscriptions, onAddCopy, onExpireIssues, t)
                    : mapSimpleBody(subscriptions, onAddCopy, onExpireIssues, t)
                : undefined,
        subscriptionCount: subscriptions?.totalHits,
        isLoading: isLoadingMeta || isLoadingData
    };
};
